import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { selectorVariablesMomentsOriginals } from '../../selectors/selector_estacio_formulari_dades';
import EstacioVariables from './estacioVariables';

class EstacioDetallVariables extends Component {
    render() {
        const { dades } = this.props;

        return <EstacioVariables editable={false} dades={dades}/>;
    }
}

EstacioDetallVariables.propTypes = {
    dades: PropTypes.array
};

const mapStateToProps = (state) => {
    return {
        dades: selectorVariablesMomentsOriginals(state)
    };
};
const mapDispatchToProps = null;

export default connect(mapStateToProps, mapDispatchToProps)(EstacioDetallVariables);



// WEBPACK FOOTER //
// ./src/components/estacio/estacioDetallVariables.js